export default __webpack_public_path__ + "static/media/medium.74ee6371.svg";